//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getStyle } from '@/utils/style'
import ComponentWrapper from '@/components/Editor/ComponentWrapper'
import { changeStyleWithScale } from '@/utils/translate'
import { connectMqtt } from '@/utils/mqtt'
import { modelData } from '@/utils/mqtt'

export default {
    components: { ComponentWrapper },
    data() {
        return {
            canvasStyleData: { // 页面全局数据
                width: 1200,
                height: 740,
                scale: 100,
            },
            componentData: [], // 画布组件数据
            modelData,
            loading: false,
            url: 'https://jisvsl.joshvm.com/history',
            // url: 'http://localhost:8080/history',
            menuShow: false,
            menu: {
                top: 0,
                left: 0,
            }
        }
    },
    created() {
        // this.componentData = JSON.parse(JSON.parse(localStorage.getItem('canvasData')))
        // this.canvasStyleData = JSON.parse(localStorage.getItem('canvasStyle'))
        let token = this.$route.query.A
        if(token) {
            this.$store.commit('SET_STATUS', token)
            this.$store.commit('setEditMode', 'show')
            this.getComponentData()
        }
    },
    methods: {
        changeStyleWithScale,
        
        getStyle,

        handleContextMenu(e) {
            e.stopPropagation()
            e.preventDefault()

            // 计算菜单相对于编辑器的位移
            this.menuShow = true
            let target = e.target
            this.menu.top = e.offsetY
            this.menu.left = e.offsetX

            while (target instanceof SVGElement) {
                target = target.parentNode
            }

            while (!target.className.includes('show')) {
                this.menu.left += target.offsetLeft
                this.menu.top += target.offsetTop
                target = target.parentNode
            }
        },

        handleMouseDown(e) {
            // 左键
            if(e.button == 0) {
                this.menuShow = false
            }
        },

        getComponentData() {
            let imei = this.$route.query.M
            let appIdentification = this.$route.query.N
            let appVendor = this.$route.query.E
            let appVersion = this.$route.query.V
            let webId = this.$route.query.W
            let appId = this.$route.query.P
            let form = {
                imei: imei,
                appIdentification: appIdentification,
                appSupplier: appVendor,
                appV: appVersion,
                devId: this.$route.query.D,
                appId: appId
            }

            this.loading = true
            this.request({
                url: '/web/dev-bid/view',
                method: 'post',
                data: form
            }).then(response => {
                let result = response.result.webString
                this.componentData = JSON.parse(result.substring(1, result.length - 1))
                this.init(imei, appIdentification, appVendor, appVersion, appId, webId)
            }).catch(error => {
                this.loading = false
                this.$message({
                    message: error.errmsg == undefined ? '页面解析异常' : error.errmsg,
                    type: 'error',
                    duration: 3 * 1000
                })
            })
        },

        init(imei, appName, appVendor, appVersion, appId, webId) {
            let topics = []
            let modulars = []
            // 是否有某个图表 line bar pie
            let echarts = [false, false, false,]
            this.componentData.forEach(element => {
                if(element.events.subscribe) {
                    topics.push(imei + '/' + appName + '/' + appVendor + '/' + appVersion + '/' + element.events.subscribeTopic)
                    let modular = {
                        key: element.events.subscribeTopic,
                        id: element.id
                    }
                    modulars.push(modular)
                }
                if(element.component == 'v-input') {
                    this.$set(modelData, element.id, '')
                } else if(element.component == 'v-line') {
                    echarts[0] = true
                } else if(element.component == 'v-bar') {
                    echarts[1] = true
                } else if(element.component == 'v-pie') {
                    echarts[2] = true
                }
            });
            connectMqtt(imei, appName, appVendor, appVersion, appId, webId, topics, modulars, echarts)
            this.loading = false
        },
        toHistory() {
            window.open(this.url + '?A=' + this.$route.query.A + '&M=' + this.$route.query.M + '&N=' + this.$route.query.N
        + '&E=' + this.$route.query.E + '&V=' + this.$route.query.V + '&D=' + this.$route.query.D + '&P=' + this.$route.query.P + '&W=' + this.$route.query.W)
            this.menuShow = false
        }
    }
}
